import * as Dati from "../../Dati";

export interface INavConfig {
    Title: string;
    Href: string;
}

export const MainNav: INavConfig[] = [
    { Title: "Cessione Pubblico Statale", Href: "/dpa/cps" },
    { Title: "Deleghe Pubblico Statale", Href: "/dpa/dps" },
    { Title: "Pensionati", Href: "/dpa/pensioners" }
];

export const Nav: { [Page: string]: INavConfig[] } = {};
Nav["Main"] = [
    { Title: "Cessione Pubblico", Href: "loan_form" },
    { Title: "Coesistenze", Href: "other_liabilities_form" },
    { Title: "Anzianità di Servizio", Href: "employment_form" },
    { Title: "Simulazioni", Href: "loan_simulation" }
];
Nav["DPS"] = [
    { Title: "Deleghe Pubblico", Href: "loan_form" },
    { Title: "Coesistenze", Href: "other_liabilities_form" },
    { Title: "Anzianità di Servizio", Href: "employment_form" },
    { Title: "Simulazioni", Href: "loan_simulation" }
];
Nav["Pensioners"] = [{ Title: "Pensionati", Href: "pensioners" }];

export const MinNetSalary = 500;
export const MinNetPension = 0.1;
export const MaxNetPension = 999999;
export const MinDistraintSum = 0;
export const MaxDistraintSum = 9999;

export enum Messages {
    IndicateDebt = "Indicare Residuo Debito",
    IndicateDebtAndExpiryDate = "Indicare: Residuo Debito e Data Scadenza",
    IndicateLoanAmountAndExpiryDate = "Indicare: Importo Rata e Data Scadenza",
    IndicateLoanAmountDebtAndExpiryDate = "Indicare: Importo Rata, Residuo Debito e la Data Scadenza",
    IdicateExpiryDate = "Indicare la Data Scadenza",
    IndicateLoanAmount = "Indicare Importo Rata",
    IndicateLoanAmountAndDebt = "Indicare: Importo Rata e Residuo Debito",
    IndicatePeriod = "Valorizzare i Periodi Contributivi",
    IndicateType = "Indicare la Tipologia di Contribuzione"
}

export enum DaysNumber {
    AgricultureYear = 104,
    Year = 365,
    Month = 30,
    Week = 7
}

export enum MonthsNumber {
    Year = 12
}

export enum WeeksNumber {
    Month = 4
}

export const Distraints = ["PignoramentoAlimenti", "PignoramentoBancheAssicurazioni", "PignoramentoTributi", "PignoramentoAltriCreditori"];

export const LiabilityTypes: Dati.TDictTipo = {};
LiabilityTypes["Delega"] = new Dati.CTipo("Delega", "Delega");
LiabilityTypes["Cessione"] = new Dati.CTipo("Cessione", "Cessione");
LiabilityTypes["PignoramentoAlimenti"] = new Dati.CTipo("PignoramentoAlimenti", "Pignoramento Alimenti");
LiabilityTypes["PignoramentoBancheAssicurazioni"] = new Dati.CTipo("PignoramentoBancheAssicurazioni", "Pignoramento Banche Assicurazioni");
LiabilityTypes["PignoramentoTributi"] = new Dati.CTipo("PignoramentoTributi", "Pignoramento Tributi");
LiabilityTypes["PignoramentoAltriCreditori"] = new Dati.CTipo("PignoramentoAltriCreditori", "Pignoramento Altri Creditori");
LiabilityTypes["Alimenti"] = new Dati.CTipo("Alimenti", "Alimenti");
LiabilityTypes["AltriPrestiti"] = new Dati.CTipo("AltriPrestiti", "Altri Prestiti");

export const DpsLiabilityTypes: Dati.TDictTipo = {};
DpsLiabilityTypes["DelegaRinnovo"] = new Dati.CTipo("DelegaRinnovo", "Delega Rinnovo");
DpsLiabilityTypes["DelegaTerzaBattuta"] = new Dati.CTipo("DelegaTerzaBattuta", "Delega Terza Battuta");
DpsLiabilityTypes["Cessione"] = new Dati.CTipo("Cessione", "Cessione");
DpsLiabilityTypes["PignoramentoAlimenti"] = new Dati.CTipo("PignoramentoAlimenti", "Pignoramento Alimenti");
DpsLiabilityTypes["PignoramentoBancheAssicurazioni"] = new Dati.CTipo("PignoramentoBancheAssicurazioni", "Pignoramento Banche Assicurazioni");
DpsLiabilityTypes["PignoramentoTributi"] = new Dati.CTipo("PignoramentoTributi", "Pignoramento Tributi");
DpsLiabilityTypes["PignoramentoAltriCreditori"] = new Dati.CTipo("PignoramentoAltriCreditori", "Pignoramento Altri Creditori");
DpsLiabilityTypes["Alimenti"] = new Dati.CTipo("Alimenti", "Alimenti");
DpsLiabilityTypes["AltriPrestiti"] = new Dati.CTipo("AltriPrestiti", "Altri Prestiti");

export const Insurers: Dati.TDictTipo = {};
Insurers["GAIIL"] = new Dati.CTipo("GAIIL", "GAIIL");
Insurers["SGI"] = new Dati.CTipo("SGI", "SGI");
Insurers["OtherInsurer"] = new Dati.CTipo("OtherInsurer", "Altri Assicuratori");

export const NoInsurers: Dati.TDictTipo = {};
NoInsurers["NoInsurer"] = new Dati.CTipo("NoInsurer", "Nessuno");

export const ContributionTypes: Dati.TDictTipo = {};
ContributionTypes["0"] = new Dati.CTipo("0", "Contratto a Tempo Indeterminato");
ContributionTypes["1"] = new Dati.CTipo("1", "Contratto a Tempo Determinato");
ContributionTypes["2"] = new Dati.CTipo("2", "Lavoro Dipendente");
ContributionTypes["3"] = new Dati.CTipo("3", "Titolare di Impresa Commerciale");
ContributionTypes["4"] = new Dati.CTipo("4", "Apprendista");
ContributionTypes["5"] = new Dati.CTipo("5", "Lavoratore Agricolo (Giornaliero)");
ContributionTypes["6"] = new Dati.CTipo("6", "Servizio Militare");
ContributionTypes["7"] = new Dati.CTipo("7", "Ricongiunzione");
ContributionTypes["8"] = new Dati.CTipo("8", "Malattia");
ContributionTypes["9"] = new Dati.CTipo("9", "Riscatto");
ContributionTypes["10"] = new Dati.CTipo("10", "PALS Obbligatoria");
ContributionTypes["11"] = new Dati.CTipo("11", "Contr.Figurativo per ASPI");
ContributionTypes["12"] = new Dati.CTipo("12", "Contr.Figurativo per Mini ASPI");
ContributionTypes["13"] = new Dati.CTipo("13", "Disoccupazione");
ContributionTypes["14"] = new Dati.CTipo("14", "Infortunio");
ContributionTypes["15"] = new Dati.CTipo("15", "Cassa Integrazione");
ContributionTypes["16"] = new Dati.CTipo("16", "Attività di Collaborazione");
ContributionTypes["17"] = new Dati.CTipo("17", "Disoccupazione Agricola");
ContributionTypes["18"] = new Dati.CTipo("18", "Trattamento Speciale Agricolo");

export const ContractTypes: Dati.TDictTipo = {};
ContractTypes["Undetermined"] = new Dati.CTipo("Undetermined", "Indeterminato");
ContractTypes["DeterminedMinor"] = new Dati.CTipo("DeterminedMinor", "Determinato minore Piano Ammortamento");
ContractTypes["DeterminedMajor"] = new Dati.CTipo("DeterminedMajor", "Determinato maggiore uguale Piano Ammortamento");

export const DurationValues: Dati.TDictTipo = {};
["24", "36", "48", "60", "72", "84", "96", "108", "120"].forEach(item => {
    DurationValues[item] = new Dati.CTipo(item, item);
});

export const GenderTypes: Dati.TDictTipo = {};
GenderTypes["Man"] = new Dati.CTipo("Man", "Uomo");
GenderTypes["Woman"] = new Dati.CTipo("Woman", "Donna");

export const WorkingHoursTypes: Dati.TDictTipo = {};
WorkingHoursTypes["FullTime"] = new Dati.CTipo("FullTime", "Tempo pieno");
WorkingHoursTypes["VerticalPartTime"] = new Dati.CTipo("VerticalPartTime", "Part Time Verticale");
WorkingHoursTypes["HorizontalPartTime"] = new Dati.CTipo("HorizontalPartTime", "Part Time Orizzontale");



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/Constants.ts